import React, { Component } from "react";

export default class Wrapper extends Component {
  render() {
    const { config, children } = this.props;
    const { compact, title, intro, remark } = config;

    return (
      <div
        className={`form ${compact ? "form--compact" : ""}${
          config.class || ""
        }`}
      >
        {!title ? null : <h1>{title}</h1>}
        {!intro ? null : <p className="form__intro">{intro}</p>}
        {!remark ? null : <div className="form__remark">{remark}</div>}
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Form/Wrapper.js